<template>
    <span>
        <span v-if="value" class="badge badge-primary">Published</span>
        <span v-else class="badge badge-warning">Draft</span>
    </span>
</template>
<script>
import V from 'voca';

export default {
    data() {
        return {

        }
    },

    props: ['initialValue', 'css'],

    computed: {
        value() {
            return this.initialValue;
        }
    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/PublishStatusComponent.vue